export default {
  label: {
    filterTitle: 'Filtro de etiquetas en árbol',
  },
};
